
interface ICitizenStatCard {
  title: string;
  value: string | number;
}

const CitizenStatCard = (props: ICitizenStatCard) => {
  const { title, value } = props;

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border-[1px] border-border-color bg-white px-8 py-4">
      <h3 className="text-[#4B5563]">{title}</h3>
      <p className="text-2xl font-bold text-headings-font-color">{value}</p>      
    </div>
  );
};

export default CitizenStatCard;
